import PhoneNumberText from './PhoneNumberText';

export default PhoneNumberText;
